import { PageTitle } from "@/components/shared/title/page-title";
import * as React from "react";
import { LocationProvider } from "../locations/context/Location";
import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { Roots } from "./RootsPage";
import { RootProvider } from "./context/RootContext";
import { RootStateProvider } from "./context/RootStateContext";

type Props = {};

const RootPage = (props: Props) => {
	return (
		<>
			<PageTitle title="Roots Management" />
			<LocationProvider>
				<RootStateProvider>
					<RootTypeProvider>
						<RootProvider>
							<Roots />
						</RootProvider>
					</RootTypeProvider>
				</RootStateProvider>
			</LocationProvider>
		</>
	);
};

export default RootPage;
